module.exports = __webpack_public_path__ + "static/media/md-qr-scanner.f2671f20.svg";